var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.328 21.328"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    "data-name": "Group 612"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.414 1.414 18.5 18.5",
    "data-name": "Line 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.914 1.414-18.5 18.5",
    "data-name": "Line 4"
  }))));
};
export default SvgCross;